import { combineReducers } from 'redux';
import * as types from './types';

const pageHistory = (state = {}, action) => {
    const { payload } = action;
    switch (action.type) {
        case types.ADD_PAGE:
            return state[payload]
                ? state
                : {
                      ...state,
                      ...{ [payload]: [] },
                  };
        case types.ADD_VISUALISATION:
            return {
                ...state,
                ...{
                    [payload.id]: [
                        ...state[payload.id],
                        payload.vizType,
                    ],
                },
            };
        default:
            return state;
    }
};

const active = combineReducers({
    pageHistory,
});

export default active;
